import { EdgeTypes } from '@xyflow/react'
import { WaypointEdge } from './WaypointEdge'

export const edgeTypes: EdgeTypes = {
  waypoint: WaypointEdge,
}

export { WaypointEdge } from './WaypointEdge'
export * from './waypointPath'
